import api from '@/store/api/bespoke'
import * as mutationTypes from './mutation-types'
import { handleApiCall } from '@/store/utils'

const initialState = () => ({
    bespoke: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        bespoke: state => state.bespoke
    },
    actions: {
        showBespoke: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.showBespoke, data, mutationTypes.SET_BESPOKE),
        updateBespoke: ({ dispatch }, data) => handleApiCall({ dispatch }, api.updateBespoke, data),
        removeBespoke: ({ dispatch }, data) => handleApiCall({ dispatch }, api.removeBespoke, data),
        resetBespoke: async ({commit}) => commit(mutationTypes.RESET_BESPOKE)
    },
    mutations: {
        [mutationTypes.SET_BESPOKE]: (state, data) => state.bespoke = data,
        [mutationTypes.RESET_BESPOKE]: (state) => Object.assign(state, initialState())
    }
}
